module.exports = __webpack_public_path__ + "static/media/googlePlay@2x.6bb2711b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/googlePlay@2x.png
// module id = 93
// module chunks = 0